import api from 'helpers/api';
import { reverse } from 'named-urls';
import { urls } from 'routes/api';

export default class User {
    constructor(id_user = 0) {
        this.id_user = id_user;
    }

    async list(params) {
        let url = reverse(urls.admin.user.get);
        const { data } = await api.get(url, { params: params });
        return data;
    }

    async show() {
        let url = reverse(urls.admin.user.edit, { id_user: this.id_user });
        const { data } = await api.get(url);
        return data;
    }

    async update(values) {
        let url = reverse(urls.admin.user.edit, { id_user: this.id_user });
        const { data } = await api.put(url, values);
        return data;
    }

    async options() {
        let url = reverse(urls.admin.user.options, { id_user: this.id_user });
        const { data } = await api.get(url);
        return data;
    }

    async save(values) {
        return this.update(values);
    }
}
